import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { useNavigate } from 'react-router-dom';
import { FaRegEye } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import Select, { components } from 'react-select';
import { BsPeopleFill } from "react-icons/bs";
import { CiViewList } from "react-icons/ci";
import axios from "axios";
import { VscVerified } from "react-icons/vsc";
import { MdOutlineDangerous } from "react-icons/md";

function Technician_Verify() {
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const [callList, setCallList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCallId, setSelectedCallId] = useState(null);
    const [approvalStatus, setApprovalStatus] = useState("");
const [filterStatus, setFilterStatus] = useState("");


    const handleVerifyClick = (id) => {
        setSelectedCallId(id);
        setApprovalStatus("VERIFIED");
        setShowModal(true);
    };

    const handleRejectClick = (id) => {
        setSelectedCallId(id);
        setApprovalStatus("REJECTED"); 
        setShowModal(true);
    };

 
const fetchComplaints = async () => {
  try {
    const res = await axios.get("https://api.skyguard.group/api/fetch-complaint");
    const complaints = res.data;

    // Map complaints with parsed item details
    const complaintsWithDetails = complaints.map(complaint => {
      const parsedItemDetails = JSON.parse(complaint.item_details || "[]");
      return { ...complaint, parsedItemDetails };
    });

    // Filter completed calls
    const completedCalls = complaintsWithDetails.filter(
      complaint => complaint.status === "COMPLETED OC"
    );

    // Filter complaints where any technician status is FAILED
    const failedCalls = complaintsWithDetails.filter(
      complaint =>
        Array.isArray(complaint.technicians) &&
        complaint.technicians.some(tech => tech.status === "FAILED")
    );

    console.log("Completed calls:", completedCalls);
    console.log("Failed calls:", failedCalls);

    // Set state (you can use two separate states or combine them)
    // setCallList({ completed: completedCalls, failed: failedCalls });

    const allCalls = [...completedCalls, ...failedCalls];
setCallList(allCalls);

  } catch (err) {
    console.error(err);
  }
};


    useEffect(() => {
        fetchComplaints();
    }, []);

    const handleConfirmVerify = async () => {
        try {
            await axios.put("https://api.skyguard.group/api/verify-complaint-call", {
                id: selectedCallId,
                approval_status: approvalStatus
            });

            alert("Call Verified Successfully");

            setShowModal(false);
            fetchComplaints();
        } catch (error) {
            console.error(error);
        }
    };


    const handleConfirmStatus = async () => {
        try {
            await axios.put("https://api.skyguard.group/api/verify-complaint-call", {
                id: selectedCallId,
                approval_status: approvalStatus,
            });

            // alert(`Call ${approvalStatus} Successfully`);
            showToast(`Call ${approvalStatus} Successfully`, 'success');
            setShowModal(false);
            fetchComplaints();
        } catch (error) {
            console.error(error);
            showToast('Failed To Update Call Status!', 'danger');
        }
    };

    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />

                <h3 className='my-3 fw-bold fs-5 golos'>Verify Technician </h3>
                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>

                    <table className="table table-bordered table-striped text-center table-sm align-middle">
                        <thead className="table-info">
                            <tr>
                                <th>SN No</th>
                                  <th>Actions</th>
                                  <th>SR No.</th>
                                <th>Party Name</th>
                                <th>Phone</th>
                                <th>Status </th>
                              
                            </tr>
                        </thead>
<tbody>
  {callList.length > 0 ? (
    callList.map((call, index) => {
      // Check if any technician has FAILED status
      const hasFailedTech =
        Array.isArray(call.technicians) &&
        call.technicians.some(tech => tech.status === "FAILED");

      return (
        <tr
          key={call.id || index}
          className={hasFailedTech ? "table-danger" : ""}
        >
          <td>{call.id}</td>
          <td>
            {call.approval_status === "VERIFIED" ? (
              <button className="btn btn-success btn-sm">Send OTP</button>
            ) : (
              <VscVerified
                size={26}
                className="text-primary"
                title="Verify Call"
                style={{ cursor: "pointer" }}
                onClick={() => handleVerifyClick(call.id)}
              />
            )}

            {call.approval_status?.toUpperCase() === "REJECTED" ? (
              <button className="btn btn-danger btn-sm mx-2">
                Call Rejected
              </button>
            ) : (
              <MdOutlineDangerous
                size={26}
                className="text-danger mx-2"
                title="Reject Call"
                style={{ cursor: "pointer" }}
                onClick={() => handleRejectClick(call.partyid)}
              />
            )}
          </td>

          <td>{`CMP/${call.id}/${call.branch}`}</td>
          <td className="text-wrap">{call.party_name}</td>
          <td className="text-wrap text-break">
            {[call.party_mobile, call.party_phone, call.party_phone2, call.party_phone3, call.party_phone4]
              .filter(Boolean)
              .join(", ")}
          </td>
          <td>{call.status}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: "center" }}>
        No Calls Found
      </td>
    </tr>
  )}
</tbody>
                    </table>
                </div>


                {showModal && (
                    <>
                        <div className="modal show fade d-block" tabIndex="-1">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">

                                    <div className="modal-header">
                                        <h5 className="modal-title">
                                            {approvalStatus === "VERIFIED" ? "Confirm Verification" : "Confirm Rejection"}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowModal(false)}
                                        ></button>
                                    </div>

                                    <div className="modal-body">
                                        <p>
                                            Are you sure you want to {approvalStatus.toLowerCase()} this call?
                                        </p>
                                    </div>

                                    <div className="modal-footer">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            className={`btn ${approvalStatus === "VERIFIED" ? "btn-primary" : "btn-danger"}`}
                                            onClick={handleConfirmStatus}
                                        >
                                            OK
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Backdrop */}
                        <div className="modal-backdrop fade show"></div>
                    </>
                )}


            </div>
        </div>
    )
}

export default Technician_Verify